module.exports = __webpack_public_path__ + "static/media/bulb.d6f7022b.svg";